import { Box, Text, VStack } from '@chakra-ui/react'
import { LuInbox } from 'react-icons/lu'

// eslint-disable-next-line no-unused-vars -- Icon is used in JSX below; eslint config has no react plugin to detect JSX usage
export function EmptyState({ icon: Icon = LuInbox, message, children }) {
  return (
    <VStack py={10} gap={3}>
      <Box color="var(--mc-text-muted)" fontSize="2xl">
        <Icon />
      </Box>
      <Text color="var(--mc-text-muted)" fontSize="sm">{message}</Text>
      {children}
    </VStack>
  )
}
